













import { Component, Prop, Vue } from 'vue-property-decorator';
import ConceptsListGroupedByPhases from '@/components/knowledge/concepts/ConceptsListGroupedByPhases.vue';
import type { Phase } from '@/models/phase';
import type { Concept } from '@/models/concept';

@Component({
    name: 'GlobalTopics',
    components: {
        ConceptsListGroupedByPhases,
    },
})
export default class GlobalTopics extends Vue {
    @Prop() private phases: Phase[];
    @Prop() private originalConcepts: Concept[];
}
